import styles from "./SettingsAccounts.module.scss";
import useSettingsAccounts from "./useSettingsAccounts";
import Card from "../../../common/Card";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import {AppStaticDropdown} from "../../../common/AppStaticDropdown";
import React from "react";
import Button from "../../../common/Button";
import {PERIOD_TYPE} from "../../../slices/transactionsSlice";
import {AccountsDropdown} from "../../../common/AccountsDropdown";
import {Content, ContentFixed} from "../../../common/Content";
import {SettingsMenuMobile} from "../Settings";
import {SettingsContent} from "../SettingsContent";
import {SettingsTopMenu} from "../SettingsTopMenu";

const SettingsAccounts = () => {
  const {
    t,
    submit,
    updateSetting,
    editedSettings,
    availableAccounts
  } = useSettingsAccounts();

  const periods = Object.keys(PERIOD_TYPE).map(pt => ({
    value: PERIOD_TYPE[pt].position,
    label: PERIOD_TYPE[pt].chooserLabel(t)
  }));

  return (
    <Content>
      <ContentFixed>
        <SettingsTopMenu title="header_title_settings_accounts"/>

        <SettingsMenuMobile/>
      </ContentFixed>

      <SettingsContent>
        <Card>
          <Form onSubmit={submit} className={styles.form}>
            <Form.Group as={Row} className="mb-2" controlId="settings-default-account">
              <Form.Label column sm={5} md={4} lg={4}>{t("settings_accounts_editor_field_default_account")}</Form.Label>
              <Col sm={7} md={6} lg={4}>
                <AccountsDropdown
                  value={editedSettings.defaultTransactionsAccount}
                  onChange={updateSetting("defaultTransactionsAccount")}
                  accounts={availableAccounts}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-4" controlId="settings-default-transactions-period">
              <Form.Label column sm={5} md={4} lg={4}>
                {t("settings_accounts_editor_field_default_transactions_period")}
              </Form.Label>
              <Col sm={7} md={6} lg={4}>
                <AppStaticDropdown
                  value={editedSettings.defaultTransactionsPeriod}
                  choices={periods}
                  onChange={updateSetting("defaultTransactionsPeriod")}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col sm={5} md={4} lg={4}/>
              <Col sm={7} md={6} lg={4}>
                <Button type="submit">{t("btn_save_settings_accounts")}</Button>
              </Col>
            </Form.Group>
          </Form>
        </Card>
      </SettingsContent>
    </Content>
  );
};

export default SettingsAccounts;
